import success from "../../../assets/success.png";

function Success() {
  return (
    <div className="h-[calc(100vh-165px)] sm:h-full flex flex-col items-center justify-center px-4">
      <div className="max-w-[400px] flex flex-col items-center justify-center">
        <img
          src={success}
          className="w-[75px] mb-4 text-center"
          alt="success"
        />
        <p className="text-[#1F2328] text-xl text-center font-bold mb-4">
          Success! Your Reimbursement request has been sent
        </p>
        <p className="text-[#60656D] text-center mb-4">
          Our reimbursement request is processed! You'll receive it within 5-7
          business days. For help, contact our support team. Thanks for your
          patience!
        </p>
        <p className="text-[#60656D] text-center mb-4">
          The additional instruction has been sent to your email.
        </p>
      </div>
    </div>
  );
}

export default Success;